import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Eyebrow, Empty, Skeleton } from "../components/ui/primitives";
import { get } from "../lib/api";
import { fmtDateTime } from "../lib/format";
import { EVENT_LABEL, STATUS_LABEL } from "../lib/labels";
import type { ActivityEvent } from "../lib/types";
import { useCompany } from "../lib/company";

/** Timeline auditable (append-only en BD): quién, cuándo y qué. */
export function ActivityPage() {
  const { companyId, qs } = useCompany();
  const q = useQuery({ queryKey: ["activity", companyId], queryFn: () => get<ActivityEvent[]>(`/activity${qs({ limit: 300 })}`), refetchInterval: 10_000 });
  return (
    <div className="mx-auto w-full max-w-[1000px] px-4 pb-24 pt-5 md:px-8 md:pb-12 md:pt-8">
      <Eyebrow>Auditoría</Eyebrow>
      <h1 className="m-0 mt-2 font-display text-[32px] font-medium leading-[1.1] tracking-[-0.025em]">Actividad</h1>
      <p className="mb-6 mt-2 text-[14px] text-mu">Registro append-only: la base de datos rechaza modificar o borrar eventos.</p>
      {!q.data && <Skeleton className="h-64" />}
      <div className="flex flex-col">
        {q.data?.map((e) => (
          <div key={e.id} className="grid grid-cols-[96px_1fr] gap-3 border-t border-ln py-2.5 text-[14px] leading-snug sm:grid-cols-[130px_1fr_auto]">
            <span className="font-mono text-[12px] text-mu">{fmtDateTime(e.at)}</span>
            <span>{EVENT_LABEL[e.type] ?? e.type}{e.type === "mission.status_changed" ? `: ${STATUS_LABEL[String(e.payload.from)] ?? "—"} → ${STATUS_LABEL[String(e.payload.to)] ?? "—"}` : ""}{e.payload.reason ? <span className="text-mu"> · {String(e.payload.reason).slice(0, 160)}</span> : null}</span>
            <span className="flex items-center gap-2 font-mono text-[11px] text-mu max-sm:col-start-2">{e.actorType}{e.missionId && <Link to={`/missions/${e.missionId}`} className="text-ok hover:underline">ver misión</Link>}</span>
          </div>
        ))}
        {q.data && !q.data.length && <Empty>Sin eventos.</Empty>}
      </div>
    </div>
  );
}
